import { AppDispatch } from '../../../../app/store';
import { TpDataContext } from '../../../../data/interfaces';
import { FORM_DATATYPES, TpAutoFormDef, promptAutoForm } from '../../../../components/auto-form-modal/AutoForm';
import { addNewSection, updateSectionSettings } from '../../data/dashboardsSlice';
import { get_guid } from '../../helpers/misc';
import { TpDashboardContext, TpDashboardSectionDefinition } from '../interfaces';

export function promptSectionSettings(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  sectionDef: TpDashboardSectionDefinition,
  dispatch: AppDispatch,
) {
  const form: TpAutoFormDef = {
    title: 'Section settings',
    fields: [
      {
        id: 'title',
        name: 'Section title',
        dataType: FORM_DATATYPES.STRING,
        required: true,
        lineCount: 4,
        startContent: sectionDef.title,
      },
    ],
  };

  promptAutoForm(form).then(
    (dataForm: any) => {
      dispatch(
        updateSectionSettings({
          dashboardDefId: dashboardContext.dashboardDefId,
          id: sectionDef.id,
          title: dataForm.title,
        }),
      );
    },
    () => {},
  );
}

export function promptAddSection(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  parentId: string,
  dispatch: AppDispatch,
) {
  const form: TpAutoFormDef = {
    title: 'Create section',
    fields: [
      {
        id: 'title',
        name: 'Title',
        dataType: FORM_DATATYPES.STRING,
        required: true,
        lineCount: 4,
        startContent: '',
      },
    ],
  };

  promptAutoForm(form).then(
    (dataForm: any) => {
      dispatch(
        addNewSection({
          dashboardDefId: dashboardContext.dashboardDefId,
          parentId,
          id: get_guid(),
          title: dataForm.title,
        }),
      );
    },
    () => {},
  );
}
